module.exports = __webpack_public_path__ + "img/coin.9c7b5124.png";